import { Controller } from "@hotwired/stimulus"
import { building_complex_new_tasks_path, my_tasks_path, involved_tasks_path, all_tasks_path } from '../routes'

export default class extends Controller {
  static values = { buildingComplexId: String, filterActive: Boolean, taskScope: String }
  static targets = ["newTaskButton", "myTasksButton", "involvedTasksButton", "allTasksButton", "filterToggleButton", "listViewButton", "kanbanViewButton"]
  static outlets = ["task"]

  connect() {
    this.filterVisible = this.hasFilterToggleButtonTarget ? this.filterToggleButtonTarget.classList.contains('btn-primary') : false
    this.refreshFilterButton()
    this.updateButtonUrls()
  }



  buildingComplexIdValueChanged() {
    this.updateButtonUrls()
  }

  taskScopePathFor(scope) {
    if (scope === 'all') return all_tasks_path
    if (scope === 'my') return my_tasks_path
    return involved_tasks_path
  }

  updateButtonUrls() {
    const buildingComplexId = this.buildingComplexIdValue || 'all'
    
    if (this.hasNewTaskButtonTarget) {
      const newUrl = building_complex_new_tasks_path(buildingComplexId)
      this.newTaskButtonTarget.href = newUrl
    }
    
    if (this.hasMyTasksButtonTarget) {
      const myTasksUrl = my_tasks_path(buildingComplexId)
      this.myTasksButtonTarget.href = myTasksUrl
    }

    if (this.hasInvolvedTasksButtonTarget) {
      const involvedTasksUrl = involved_tasks_path(buildingComplexId)
      this.involvedTasksButtonTarget.href = involvedTasksUrl
    }
    
    if (this.hasAllTasksButtonTarget) {
      const allTasksUrl = all_tasks_path(buildingComplexId)
      this.allTasksButtonTarget.href = allTasksUrl
    }

    const tasksPath = this.taskScopePathFor(this.taskScopeValue)

    if (this.hasListViewButtonTarget) {
      this.listViewButtonTarget.href = tasksPath(buildingComplexId, { view_mode: 'list' })
    }

    if (this.hasKanbanViewButtonTarget) {
      this.kanbanViewButtonTarget.href = tasksPath(buildingComplexId, { view_mode: 'kanban' })
    }
  }

  filterActiveValueChanged() {
    this.refreshFilterButton()
  }

  updateFilterButtonState(isVisible) {
    console.debug('[task_breadcrumbs_controller] updateFilterButtonState', { isVisible })
    this.filterVisible = isVisible
    this.refreshFilterButton()
  }

  updateFilterIcon(isActive) {
    console.debug('[task_breadcrumbs_controller] updateFilterIcon', { isActive })
    this.filterActiveValue = isActive
    this.refreshFilterButton()
  }

  toggleFilter(event) {
    event.preventDefault()
    
    if (this.hasTaskOutlet) {
      this.taskOutlet.toggleFilter()
    }
  }

  refreshFilterButton() {
    console.debug('[task_breadcrumbs_controller] refreshFilterButton', {
      hasTarget: this.hasFilterToggleButtonTarget,
      filterVisible: this.filterVisible,
      filterActive: this.filterActiveValue
    })

    if (!this.hasFilterToggleButtonTarget) return

    const button = this.filterToggleButtonTarget
    const icon = button.querySelector('i')
    const isVisible = this.filterVisible || false

    button.classList.toggle('btn-primary', isVisible)
    button.classList.toggle('btn-outline-secondary', !isVisible)

    if (icon) {
      icon.className = this.filterActiveValue ? 'bi bi-funnel-fill' : 'bi bi-funnel'
    }
  }
}
